import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const ProductDetail = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`/api/products/${slug}`);
        setProduct(response.data.data);
      } catch (error) {
        console.error('Error fetching product:', error);
        // Find from static data
        const found = staticProducts.find(p => p.slug === slug);
        setProduct(found || null);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [slug]);

  const staticProducts = [
    {
      id: 1,
      name: 'Ductless Laminar Air Flow System',
      slug: 'ductless-laminar-air-flow-system',
      shortDescription: 'Superior levels of patient protection through filtered and sterile air tent on operation table.',
      description: 'Ductless Laminar Air flow system offers superior levels of patient protection through making filtered and sterile air tent on operation table, this Air tent does not allow the infected air to enter the air tent.',
      features: [
        'Class I (1-10 Particles) air quality near the HEPA filter',
        'Class III (100-1000 Particles) air quality on the Operation Theatre table',
        'Class IV (1000 - 10000 Particles) air Quality throughout the Operation Theatre',
        '0.18 kW blower for 90-120 FPM air velocity',
        'HEPA filter life 2 to 2.5 years',
        'UV light to prevent bacteria/fungus growth'
      ],
      specifications: { blower: '0.18 kW', airVelocity: '90-120 FPM', hepaFilterLife: '2 to 2.5 years' },
      category: 'Air Quality Systems'
    },
    {
      id: 2,
      name: 'Ozone Generator (O3 GEN)',
      slug: 'ozone-generator',
      shortDescription: 'The Magical Air Disinfectant without any chemicals.',
      description: 'O3 Gen Kills all types of bacteria, Fungus, virus molds and reduces the biological burden up to 93% with 2.5 ppm concentration within 30 minutes.',
      features: [
        'Kills all types of bacteria, Fungus, virus molds',
        'Reduces biological burden up to 93%',
        '2.5 ppm concentration within 30 minutes',
        'Ozone half life: 10 minutes',
        'Byproduct is oxygen - safe to use',
        'Chemical-free disinfection'
      ],
      specifications: {},
      category: 'Disinfection Systems'
    },
    {
      id: 3,
      name: 'Negative Ionizer',
      slug: 'negative-ionizer',
      shortDescription: 'Air purification system that improves air quality and health.',
      description: 'Air purification system that improves air quality and health with no filtration and no maintenance required.',
      features: [
        'Power consumption: 2 watt',
        'Cover area: 150 to 180 sq. Ft',
        'Improve immunity',
        'Increase metabolism',
        'No filtration required',
        'No maintenance needed',
        'ONE YEAR REPLACEMENT WARRANTY'
      ],
      specifications: { power: '2 watt', coverage: '150 to 180 sq. Ft' },
      category: 'Air Quality Systems'
    },
    {
      id: 4,
      name: 'PSA Oxygen Generation Plant',
      slug: 'psa-oxygen-generation-plant',
      shortDescription: 'On-site Oxygen Generation using PSA technology.',
      description: 'AL-MED manufactures State of the Art Oxygen Gas Generator for on-site Oxygen Generation by separating the Oxygen from the atmospheric air using Zeolite molecular Sieves and PSA technology.',
      features: [
        'Extremely clean operation - Air is the only raw material',
        'Guaranteed uninterrupted supply of oxygen',
        'Produce oxygen at place and time of your choice',
        'World\'s most efficient Zeolite molecular Sieves (ZMS)',
        'No waiting for external suppliers',
        'Cost efficient compared to cylinder oxygen'
      ],
      specifications: { pressure: '4-8 bar(g)', technology: 'PSA (Pressure Swing Adsorption)' },
      category: 'Oxygen Systems'
    },
    {
      id: 5,
      name: 'Modular Operation Theatre',
      slug: 'modular-operation-theatre',
      shortDescription: 'Complete Modular Operation Theatre system for healthcare facilities.',
      description: 'Modular Operation Theatre system for healthcare facilities with all necessary components for sterile surgical environment.',
      features: [
        'Complete modular design',
        'Easy to install',
        'Maintains sterile environment',
        'Customizable configurations',
        'SS304 construction for durability'
      ],
      specifications: {},
      category: 'Operation Theatre'
    },
    {
      id: 6,
      name: 'Air Pollution Control HUB',
      slug: 'air-pollution-control-hub',
      shortDescription: 'For public places with high footfall.',
      description: 'The Air Pollution Control HUB is installed in Public places. It takes in polluted air, processes it through filters, and sends treated air back to the environment.',
      features: [
        'For public places and high footfall areas',
        'Processes polluted air through filters',
        'Sends treated air back to environment',
        'Benefits public health'
      ],
      specifications: {},
      category: 'Air Quality Systems'
    },
    {
      id: 7,
      name: 'Isolation Ward',
      slug: 'isolation-ward',
      shortDescription: 'Advanced isolation wards with air purification and filtration.',
      description: 'Advanced isolation wards with air purification and filtration to protect healthcare workers from airborne infections.',
      features: [
        'Air purification and filtration',
        'Protects healthcare workers',
        'Functional isolation design',
        'COVID-19 response solution'
      ],
      specifications: {},
      category: 'Isolation Systems'
    },
    {
      id: 8,
      name: 'Ductless Air Handling Unit',
      slug: 'ductless-air-handling-unit',
      shortDescription: 'Maintain positive pressure and sterile air in Operation Theatre.',
      description: 'Air handling unit for operation theaters with pressure damper for desired fresh air levels.',
      features: [
        'Pressure damper for desired fresh air levels',
        'Maintains positive pressure in OT',
        'Air recirculation for sterile environment',
        'Temperature control: 18-21°C'
      ],
      specifications: { temperature: '18-21 degree Celsius' },
      category: 'Air Handling'
    },
    {
      id: 9,
      name: 'SS Pass Box',
      slug: 'ss-pass-box',
      shortDescription: 'Stainless steel pass box for operation theaters.',
      description: 'Stainless steel pass box for operation theaters ensuring sterile transfer of materials.',
      features: [
        'SS304 stainless steel construction',
        'Maintains sterile environment',
        'For OT material transfer'
      ],
      specifications: { material: 'SS304 (Stainless Steel 304)' },
      category: 'Operation Theatre'
    },
    {
      id: 10,
      name: 'Negative Pressure System with Burning Unit',
      slug: 'negative-pressure-system',
      shortDescription: 'COVID-19 response - Protect medical staff from nosocomial infection.',
      description: 'Developed for COVID-19 pandemic, this system protects medical staff from nosocomial infection. Tested in NABL accredited SRL laboratory.',
      features: [
        'Protects medical staff from nosocomial infection',
        'Tested in NABL accredited SRL laboratory',
        'HEPA filter 0.1 micron with nano-particle coating',
        'Deactivates virus and eradicates VOC',
        'Burning unit for complete sterilization'
      ],
      specifications: { hepaFilter: '0.1 micron', coating: 'Ethanol, Hydrogen peroxide, Silver nitrate, Sodium Hypochlorite, Keratin' },
      category: 'COVID-19 Solutions'
    },
    {
      id: 11,
      name: 'Laminar Air Flow',
      slug: 'laminar-air-flow',
      shortDescription: 'HEPA filtered laminar air flow for Operation Theatres.',
      description: 'Laminar Air Flow system with HEPA filter for maintaining air quality in Operation Theatres.',
      features: [
        '0.18 kW blower for 90-120 FPM air velocity',
        'Easy routine cleaning from inside the OT',
        'HEPA filter life 2 to 2.5 years',
        'UV light to prevent bacteria/fungus growth'
      ],
      specifications: { blower: '0.18 kW', airVelocity: '90-120 FPM' },
      category: 'Air Quality Systems'
    }
  ];

  const icons = {
    'Air Quality Systems': '💨',
    'Disinfection Systems': '🦠',
    'Oxygen Systems': '⚗️',
    'Operation Theatre': '🏥',
    'Isolation Systems': '🛡️',
    'Air Handling': '🌀',
    'COVID-19 Solutions': '🔬'
  };

  if (loading) {
    return (
      <div className="loading" style={{minHeight: '100vh', marginTop: '70px'}}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!product) {
    return (
      <div style={{marginTop: '70px', padding: '100px 20px', textAlign: 'center'}}>
        <h1>Product Not Found</h1>
        <p>The product you're looking for doesn't exist.</p>
        <Link to="/products" className="btn btn-primary">Back to Products</Link>
      </div>
    );
  }

  return (
    <div className="product-detail">
      <div className="container">
        {/* Breadcrumb */}
        <div style={{marginBottom: 'var(--spacing-xl)'}}>
          <Link to="/products" style={{color: 'var(--primary-color)'}}>← Back to Products</Link>
        </div>

        <div className="product-detail-grid">
          {/* Image */}
          <div className="product-detail-image">
            {product.image ? (
              <img 
                src={product.image} 
                alt={product.name}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 'var(--radius-lg)'
                }}
              />
            ) : (
              <span className="product-icon">{icons[product.category] || '🏥'}</span>
            )}
          </div>

          {/* Content */}
          <div className="product-detail-content">
            <span className="product-detail-category">{product.category}</span>
            <h1>{product.name}</h1>
            
            {/* Full Description */}
            <div style={{marginBottom: 'var(--spacing-xl)'}}>
              <p style={{fontSize: 'var(--font-size-lg)', color: 'var(--gray-600)', lineHeight: '1.8'}}>
                {product.fullDescription || product.description || product.shortDescription}
              </p>
            </div>

            {/* Features */}
            {product.features && product.features.length > 0 && (
              <div className="product-features">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Specifications */}
            {product.specifications && Object.keys(product.specifications).length > 0 && (
              <div className="product-features">
                <h3>Technical Specifications</h3>
                <ul>
                  {Object.entries(product.specifications).map(([key, value]) => (
                    <li key={key}>
                      <strong>{key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}:</strong> {value}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* CTA Buttons */}
            <div style={{display: 'flex', gap: 'var(--spacing-md)', marginTop: 'var(--spacing-2xl)'}}>
              <Link to="/contact" className="btn btn-primary">Request Quote</Link>
              <a href="tel:+919322510636" className="btn btn-secondary">Call Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;

